import React from "react";
import { IBookNowBannerProps } from "./BookNowBannerProps";
import { Banner } from "./BookNowBannerHelpers";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import HotelSearchModal from "../HotelSearchModal/HotelSearchModal";
import { useAppSelector } from "../../../hooks";
import { brandSelector } from "../../../redux/slices/Brand/brand";

const BookNowBanner: React.FC<IBookNowBannerProps> = (props) => {
  const bannerImage = props.relationships.field_media
    ? props.relationships.field_media.relationships.field_media_image
    : null;
  const brand = useAppSelector(brandSelector);
  const logo = brand?.relationships?.field_logo?.publicUrl || "";
  const _image =
    props.relationships.field_media.relationships.field_media_image;
  let bannerSources = null;
  if (bannerImage) {
    bannerSources = [
      bannerImage.mobileImage,
      {
        ...bannerImage?.desktopImage,
        media: `(min-width: 491px)`,
      },
    ];
  }

  const [showHotelSearchModal, setShowHotelSearchModal] = React.useState(false);

  const handleOnClick = () => {
    setShowHotelSearchModal(true);
  };

  if (brand) {
    return (
      <Container fluid className="p-0 mt-5 mb-5 position-relative">
        <Banner Tag="div" className="section-banner h-100" image={_image}>
          <div className="overlay" />
          <Container
            fluid="sm"
            className="cta-container d-flex flex-column justify-content-center text-center"
          >
            <Row>
              <Col>
                {logo && (
                  <div>
                    <img src={logo} className="logo mb-5" alt={brand.name} />
                  </div>
                )}
                <Button
                  variant="light"
                  className="text-uppercase pl-5 pr-5"
                  onClick={handleOnClick}
                  aria-label="Book Now"
                >
                  Book Now
                </Button>
              </Col>
            </Row>
          </Container>
        </Banner>
        <HotelSearchModal
          location={window.location}
          show={showHotelSearchModal}
          onHide={() => {
            setShowHotelSearchModal(false);
          }}
        />
      </Container>
    );
  }
  return null;
};

export default BookNowBanner;
